import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import CardLoading from "../../../components/CardLoading";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";

function ProgressToDateTable({selectedProjId}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "project_component/fetch_projectcomponents";
  const { loading, data, count, activeObjOngoingProject } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
    })
  );

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      width:'10px',
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Components",
      dataIndex: "compName", 
    },
    {
      title: "Progress",
      dataIndex: "compPercentageCompleted", 
    },
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        mainProjectProjectId:selectedProjId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [selectedProjId]);

  if (loading ) return <CardLoading />;
  return (
    <>
      <Table
        rowSelection={false}
        className="mt-[1.25rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.componentId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
    </>
  );
}

export default ProgressToDateTable;
